import { Ticket_DetailProjection } from "@app/models/rest/ticket";

export class TicketIssue {
  ticketId: number;
  ticket: Ticket_DetailProjection;
  issues: string[];
}
